import senderIdListSaga from "./sender_id_list_saga";

export default [senderIdListSaga];
